<template>
    <div>
        <table class="table">
            <tr>
                <th width=10%>No</th>
                <th>Questionnaire</th>
                <th width=6%>Rating</th>
            </tr>
            <tr v-for="rating in ratings" @click="on_clickhandler(rating)">
                <td>{{ rating.questionnaire.name }}</td>
                <td>{{ rating.questionnaire.description }} <b-btn class="float-right">Rate</b-btn></td>
                <th>{{ rating.rating_product }}<span v-if="rating.questionnaire.double_rating"> | {{ rating.rating_process }}</span></th>
            </tr>
        </table>
    </div>
</template>

<script>

export default {
  data () {
    return {
    }
  },
  props: ['ratings', 'on_clickhandler'],
  created () {
      
  },
  watch: {
      
  },
  methods: {
  }
}
</script>
